import Cookie from 'js-cookie';

import { determineLayoutContext } from '@ott/layout-context';
import createKm from '@ott/utility-create-km';

const getLayout = (): 'mobile' | 'desktop' => {
  const { isMobileLayout } = determineLayoutContext();

  return isMobileLayout ? 'mobile' : 'desktop';
};

const track = createKm('ActivitiesWidget', {
  referrer: () => Cookie.get('referrer'),
  referrer_mrk: () => Cookie.get('referrer_mrk'),
  abst: () => Cookie.get('abst'),
  layout: getLayout,
});

type CommonParams = {
  id?: string;
  localityId: number;
  page: string;
};

type CommonParamsWithCount = CommonParams & { count: number };

const onSearchSuccess = (params: CommonParamsWithCount) =>
  track('ACT_WIDGET_SEARCH_SUCCESS', params);

const onActivityCardClick = (
  params: CommonParams & {
    offerId: number;
    selectionOrder: number;
    afterScrolling: boolean;
    isFavorite: boolean;
  }
) => track('ACT_WIDGET_ACTIVITY_CARD_CLICK', params);

const onSearchCardShow = (params: CommonParams) => track('ACT_WIDGET_SEARCH_CARD_SHOW', params);

const onSearchCardClick = (params: CommonParams) => track('ACT_WIDGET_SEARCH_CARD_CLICK', params);

const onScroll = (
  params: CommonParamsWithCount & {
    scrollOrder: number;
  }
) => track('ACT_WIDGET_SCROLL', params);

const onSearchLinkShow = (params: CommonParams) => track('ACT_WIDGET_SEARCH_LINK_SHOW', params);

const onSearchLinkClick = (params: CommonParams) => track('ACT_WIDGET_SEARCH_LINK_CLICK', params);

export default {
  onActivityCardClick,
  onScroll,
  onSearchCardClick,
  onSearchCardShow,
  onSearchLinkClick,
  onSearchLinkShow,
  onSearchSuccess,
};
